var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AboutMe'),_c('ExperienceSection'),_c('EducationSection'),_c('ResumeSection'),_c('PortfolioSection'),_c('Blog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }